import SoundManager from "source/app/services/Sound/SoundManager";
import { StartGarble, StopGarble } from "source/app/services/UI/Garble/Garble";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import * as toastr from "toastr";
import { LevelProgressBarState } from "./LevelProgressBarState";
import { IsLevelProgressBarMounted } from "./LevelProgressBarLifecycle";
import { Sounds } from "../../../../services/Sound/Sounds";

export async function WithAnimatedProgressBarAsync<TResult>(
    asyncAction: () => Promise<TResult>,
    actionName?: string
): Promise<TResult> {
    const levelProgressBar = State.ReadClass<LevelProgressBarState>(
        ESharedComponent.LevelProgressBar
    );

    if (levelProgressBar && IsLevelProgressBarMounted()) {
        try {
            levelProgressBar.setState({ isAnimated: true });

            if (actionName) {
                // for debugging
                // console.log(`loading ${actionName}`);
            }

            return await asyncAction();
        } catch (e) {
            toastr.error(e.message);
            throw e;
        } finally {
            if (IsLevelProgressBarMounted()) {
                levelProgressBar.setState({ isAnimated: false });
            }
        }
    } else {
        return await asyncAction();
    }
}
